'use client';

import { usePathname } from 'next/navigation';
import NextLink from 'next/link';
import './LanguageSwitcher.css';

export function LanguageSwitcher() {
  const pathname = usePathname();
  const isRussian = pathname.startsWith('/ru');

  const alternateHref = isRussian
    ? pathname.replace(/^\/ru/, '') || '/'
    : `/ru${pathname}`;

  return (
    <NextLink className="LanguageSwitcher" href={alternateHref}>
      {isRussian ? 'EN' : 'RU'}
    </NextLink>
  );
}
